module.exports = __webpack_public_path__ + "static/media/intro_3.ddaca970.jpg";